import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import { ShieldCheckIcon, UsersIcon, MapIcon } from 'lucide-react';
export function AboutSection() {
  return <section className="py-20 bg-slate-50" data-id="element-16">
      <div className="container mx-auto px-4" data-id="element-17">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-18">
          {/* Text Content */}
          <div className="lg:w-1/2" data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-20">
              About Global Universal Logistics
            </h2>

            <div className="space-y-4 text-slate-600 text-lg leading-relaxed mb-8" data-id="element-21">
              <p data-id="element-22">
                Global Universal Logistics is a specialist provider of emergency
                parcel and item delivery services across the UK.
              </p>
              <p data-id="element-23">
                We operate as an emergency delivery driving agency, supplying
                reliable and professional drivers to meet a wide range of
                delivery needs at short notice.
              </p>
              <p data-id="element-24">
                Our logistics solutions support businesses and individuals
                requiring urgent transport, relocation assistance, furniture
                delivery, or long-term driver support.
              </p>
              <p data-id="element-25">
                With a nationwide network and experienced team, we ensure every
                delivery is handled efficiently, safely, and professionally.
              </p>
            </div>

            <Link to="/about" data-id="element-26">
              <Button variant="outline" size="lg" className="bg-white" data-id="element-27">
                Learn More About Us
              </Button>
            </Link>
          </div>

          {/* Decorative Visual */}
          <div className="lg:w-1/2 w-full" data-id="element-28">
            <div className="grid grid-cols-2 gap-4" data-id="element-29">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center justify-center aspect-square" data-id="element-30">
                <ShieldCheckIcon className="h-12 w-12 text-primary mb-4" data-id="element-31" />
                <h3 className="font-bold text-slate-900" data-id="element-32">Secure & Safe</h3>
                <p className="text-sm text-slate-500 mt-2" data-id="element-33">
                  Fully insured and vetted operations
                </p>
              </div>
              <div className="bg-primary p-6 rounded-2xl shadow-sm flex flex-col items-center text-center justify-center aspect-square text-white mt-8" data-id="element-34">
                <UsersIcon className="h-12 w-12 mb-4 opacity-90" data-id="element-35" />
                <h3 className="font-bold" data-id="element-36">Expert Team</h3>
                <p className="text-sm opacity-80 mt-2" data-id="element-37">
                  Professional drivers and handlers
                </p>
              </div>
              <div className="bg-slate-900 p-6 rounded-2xl shadow-sm flex flex-col items-center text-center justify-center aspect-square text-white -mt-8" data-id="element-38">
                <MapIcon className="h-12 w-12 mb-4 opacity-90 text-primary" data-id="element-39" />
                <h3 className="font-bold" data-id="element-40">Nationwide</h3>
                <p className="text-sm opacity-80 mt-2" data-id="element-41">
                  Covering all of the UK
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-2xl shadow-sm border border-blue-100 flex flex-col items-center text-center justify-center aspect-square" data-id="element-42">
                <div className="text-4xl font-bold text-primary mb-2" data-id="element-43">24/7</div>
                <h3 className="font-bold text-slate-900" data-id="element-44">Availability</h3>
                <p className="text-sm text-slate-500 mt-2" data-id="element-45">
                  Always ready to deliver
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}